import React from "react";
import logo from "../../../asserts/logo_ptr.png";

const ResetPassword = () => {

    return ( 
        <div className="login-page d-flex justify-content-center align-items-center">
            <div className="content-div d-flex flex-column justify-content-center">
                <div className="text-center">
                    <img src={logo} className="logo" alt="logo" />
                </div>
                <h1 className="forget-t1 mt-4 mb-0">Reset your password</h1>
                <div className="mt-4">
                    <div className="w-100-50 margin-auto">
                        <input type="text" className="searchBox w-100" placeholder="New Password" />
                    </div>
                </div>
                <div className="d-flex mt-4">
                    <div className="w-100-50 margin-auto">
                        <input type="text" className="searchBox w-100" placeholder="Confirm Password" />
                    </div>
                </div>
                <div className="d-flex mt-4">
                    <div className="w-100-50 margin-auto">
                        <button className="pointerButton w-100">CONFIRM</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;